import HistorialService from "@/api/services/HistorialService"
import Vue from "vue"

const state = () => ({
    historiales: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "-id",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    },

    //utilizados dentro del componente time line de los historiales
    historialesTimeLine: {
        class: null,
        class_id: null,
        historiales: []
    },
    historialesTimeLinePagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "-id",
        total_count: 0
    }
})

const getters = {
    HISTORIALES: state => {
        return state.historiales
    },
    HISTORIALES_PAG: state => {
        return state.pagination
    },

    HISTORIALES_TIME_LINE: state => {
        return state.historialesTimeLine
    },
    HISTORIALES_TIME_LINE_PAG: state => {
        return state.historialesTimeLinePagination
    }
}

const mutations = {
    SET_HISTORIALES: (state, payload) => {
        state.historiales = payload
    },

    SET_HISTORIALES_PAG: (state, payload) => {
        state.pagination = payload
    },

    SET_HISTORIALES_TIME_LINE: (state, payload) => {
        state.historialesTimeLine = {
            class: payload.class,
            class_id: payload.class_id,
            historiales: payload.historiales
        }
    },

    SET_HISTORIALES_TIME_LINE_PAG: (state, payload) => {
        if (payload.total_count) {
            state.historialesTimeLinePagination.total_count = payload.total_count
        }

        if (payload.page) {
            state.historialesTimeLinePagination.page = payload.page
        }
    }
}

const actions = {
    LOAD_HISTORIALES: async ({ commit, state }, { historialEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await HistorialService.get({ historialEstado, customfilter, ...pagination })
            if (status === 200) {
                commit("SET_HISTORIALES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los historiales"
            })
        }
    },

    LOAD_HISTORIALES_TIME_LINE: async ({ commit, state }, payload) => {
        try {
            let pagination = {
                page: state.historialesTimeLinePagination.page,
                rowsPerPage: state.historialesTimeLinePagination.rowsPerPage,
                sortBy: state.historialesTimeLinePagination.sortBy
            }

            let classParam = ""
            if (payload.class && payload.class_id) {
                classParam = `?class=${payload.class}&class_id=${payload.class_id}`
            }

            let { data, status, headers } = await HistorialService.loadHistorialesTimeLine({
                classParam,
                ...pagination
            })
            if (status === 200) {
                commit("SET_HISTORIALES_TIME_LINE", {
                    class: payload.class,
                    class_id: payload.class_id,
                    historiales: data
                })
                commit("SET_HISTORIALES_TIME_LINE_PAG", { total_count: parseInt(headers["x-pagination-total-count"]) })
                return data
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los historiales, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
